
import '../scss/styles.scss'

import 'babel-polyfill'

import 'lazyload/lazyload.min'

import './src/common'
